export default "__VITE_ASSET__Bcbh1aUq__"